import styled from 'styled-components'
import { View } from '@olxbr/design-system'

const Col = styled(View)`
  display: flex;
  flex-direction: column;

  ${({ size }) =>
    size
      ? `
    width: ${size}%;
  `
      : `
    flex-grow: 1;
  `}
`

Col.displayName = 'Col'

export default Col
